/******************************************************************************
 * renameMachineReferential: correct the label of one active machine type or brand.
 *
 * The admin CRUD already accepts PUT admin/machine_types|machine_brands/{id}.
 * The body replaces the row, and translations are orphan-removed when absent,
 * so the current row is loaded first and sent back with only the label changed.
 *****************************************************************************/

/* Services */
import { api } from "../../../../../../services/api/api";
/***/

export class EmptyMachineLabelError extends Error {
  constructor() {
    super("EMPTY_LABEL");
  }
}

/**
* machineReferentialResource: admin collection for a type or brand list
*/
export function machineReferentialResource(kind: EasyTech.MachineReferentialKind) {
  return kind === "TYPE" ? "machine_types" : "machine_brands";
}

/**
* renameMachineReferential: store a new label on an existing row
* @param kind - which list the row belongs to
* @param id - row id
* @param label - the label as typed
*/
export async function renameMachineReferential(
  kind: EasyTech.MachineReferentialKind,
  id: string,
  label: string
) {
  const trimmed = label.trim().replace(/\s+/g, " ");
  if (!trimmed) throw new EmptyMachineLabelError();

  const path = "admin/" + machineReferentialResource(kind) + "/" + id;
  const current = await api.get(path) as { translations?: unknown[] };
  await api.put(path, {
    label: trimmed,
    translations: current?.translations ?? []
  });
}
/***/
